import { useEffect, useMemo, useState } from 'react';
import fetchSequenceBlocks from './data/api';
import { LOCKED, PARTIALLY_LOCKED, UNLOCKED } from './constants';

const getAllSequenceIds = ({ sections }) => {
  let allSequenceIds = [];
  const sectionToSequenceMap = {};

  Object.entries(sections).forEach(([id, section]) => {
    const { sequenceIds } = section;

    allSequenceIds = [...allSequenceIds, ...sequenceIds];
    sectionToSequenceMap[id] = sequenceIds;
  });
  return [sectionToSequenceMap, allSequenceIds];
};

const useSequenceContext = ({ sections, isFBE }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [sequenceData, setSequenceData] = useState({});
  const [courseHasLockedContent, setCourseHasLockedContent] = useState(false);

  const [sectionToSequenceMap, sequenceIds] = useMemo(() => getAllSequenceIds({ sections }), [sections]);

  const fetchSectionHasLockedContent = (sectionId) => {
    const currentSequenceIds = sectionToSequenceMap[sectionId];
    const hasLockedContent = currentSequenceIds.some(id => (
      sequenceData[id] === LOCKED || sequenceData[id] === PARTIALLY_LOCKED
    ));

    return hasLockedContent;
  };

  useEffect(() => {
    const fetchData = async () => {
      let lockedSequencesData = {};

      await Promise.all(sequenceIds.map(async (id) => {
        await fetchSequenceBlocks(id).then((data) => {
          lockedSequencesData = { ...lockedSequencesData, ...data };
        });
      }));

      const hasLockedContent = Object.values(lockedSequencesData).some(
        sequenceLockedStatus => (
          sequenceLockedStatus === LOCKED || sequenceLockedStatus === PARTIALLY_LOCKED
        ),
      );

      setCourseHasLockedContent(hasLockedContent);
      setSequenceData(lockedSequencesData);
    };

    if (isFBE) {
      fetchData();
    } else {
      const lockedSequencesData = {};
      sequenceIds.forEach(sequenceId => {
        lockedSequencesData[sequenceId] = UNLOCKED;
        setSequenceData(lockedSequencesData);
      });
    }

    setIsLoading(false);
  }, [sections, isFBE, sequenceIds]);

  return {
    courseHasLockedContent,
    fetchSectionHasLockedContent,
    isLoading,
    sequenceData,
  };
};

export default useSequenceContext;
